<template>
  <div class="w-auto text-xs">
    <div class="flex flex-col items-center text-left w-full">
      <div
        v-if="open"
        class="z-10 fixed top-0 bottom-0 left-0 right-0"
        @click="openSelect"
      />
      <div class="w-full">
        <div class="flex flex-col items-center relative">
          <!-- Select -->
          <div class="w-full z-10" @click="openSelect">
            <div
              :class="[
                'flex items-center border border-gray-200 bg-white rounded',
                { 'bg-gray-100': disabled },
              ]"
            >
              <div class="flex-1 ml-2 pr-3 truncate">
                <input
                  v-if="selected || !canAll"
                  :value="
                    selected
                      ? options.find((o) => o.value == selected).text
                      : ''
                  "
                  :class="[{'cursor-pointer': !disabled},'border-0 cursor-default outline-none ring-0 bg-transparent w-full']"
                  required
                  onkeypress="return false;"
                />
                <span v-else-if="canAll">Todos</span>
              </div>

              <div
                class="
                  text-gray-300
                  w-5
                  border-l
                  flex
                  items-center
                  border-gray-200
                "
              >
                <button
                  :class="[
                    { 'rotate-180': !open, 'cursor-default': disabled },
                    'transform flex justify-center items-center w-5 h-5 text-gray-600 outline-none focus:outline-none',
                  ]"
                  type="button"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-chevron-up w-4 h-4"
                  >
                    <polyline points="18 15 12 9 6 15"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Opciones -->
          <div
            v-show="open"
            class="z-99 w-auto absolute left-0"
            style="top: 1.4rem; min-width: 100%"
          >
            <!-- Buscador -->
            <div
              v-if="canSearch"
              class="
                p-1
                rounded-t
                border
                bg-white
                w-full
                relative
                flex
                items-center
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 text-gray-400 mr-1"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"
                />
              </svg>
              <input
                type="text"
                class="
                  flex-1
                  w-full
                  h-full
                  border-none
                  active:outline-none
                  focus:outline-none
                "
                placeholder="Buscar..."
                v-model="searchBy"
              />
              <div
                v-if="searchBy"
                @click="searchBy = null"
                class="hover:text-red-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="
                    feather feather-x
                    cursor-pointer
                    text-gray-400
                    hover:text-teal-400
                    rounded-full
                    w-3
                    h-3
                    ml-2
                  "
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
            </div>

            <!-- Listado -->
            <div
              class="
                max-h-56
                shadow-xl
                bg-white
                border-l border-b border-r
                z-40
                w-full
                rounded-b
                max-h-select
                overflow-y-auto
                select-none
              "
            >
              <div v-if="optionsComp.length === 0" class="text-gray-500 p-2">
                No hay resultados para mostrar.
              </div>
              <!-- Todos -->
              <div
                v-if="canAll && !searchBy"
                :class="[
                  'flex flex-col w-full bg-white list-item hover:bg-gray-200',
                ]"
                @click="clickOption('')"
              >
                <div
                  class="
                    cursor-pointer
                    w-full
                    border-gray-100
                    rounded-t
                    border-b
                    hover:bg-teal-100
                  "
                >
                  <div
                    class="
                      flex
                      w-full
                      items-center
                      border-transparent border-l-2
                      relative
                      hover:border-teal-100
                    "
                  >
                    <div class="w-full items-center flex">
                      <div class="mx-2 leading-6">Todos</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Row Opciones -->
              <div
                v-for="(opcion, index) in optionsComp"
                :key="index"
                :class="[
                  'flex flex-col w-full bg-white list-item hover:bg-gray-200',
                ]"
                @click="clickOption(opcion.value)"
              >
                <div
                  class="
                    py-2
                    cursor-pointer
                    w-full
                    border-gray-100
                    rounded-t
                    border-b
                    hover:bg-teal-100
                  "
                >
                  <div
                    class="
                      flex
                      w-full
                      items-center
                      border-transparent border-l-2
                      relative
                      hover:border-teal-100
                    "
                  >
                    <div class="w-full items-center flex">
                      <div class="mx-2 leading-4">
                        {{ opcion.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref, toRef } from "vue";

export default defineComponent({
  emits: ["update:selected"],
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      validator: function (value) {
        return value.every((v) => {
          return (v.value || v.value == 0) && v.text;
        });
      },
    },
    selected: {
      type: String,
      required: true,
    },
    canSearch: {
      type: Boolean,
      required: false,
      default: true,
    },
    canAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    let searchBy = ref(null);
    let open = ref(false);
    let disabled = toRef(props, "disabled");

    const optionsComp = computed(() => {
      let options = props.options;
      if (searchBy.value) {
        options = options.filter((o) => {
          let regex = new RegExp(`${searchBy.value.trim().toLowerCase()}`);
          let opcion = o.text ? o.text.trim().toLowerCase() : o.text;
          return regex.test(opcion);
        });
      }
      return options;
    });

    const clickOption = (value) => {
      open.value = false;
      emit("update:selected", value);
    };

    const openSelect = () => {
      if (!disabled.value) {
        open.value = !open.value;
      }
    };
    return { searchBy, optionsComp, open, clickOption, openSelect };
  },
});
</script>

<style scoped>
input {
  color: transparent;
  text-shadow: 0 0 0 black;
}
input:focus {
  outline: none;
}
.z-99 {
  z-index: 99;
}
</style>